/**
 * The name roller's stylesheet, injected with the row and removed with it.
 *
 * It is deliberately quiet: this sits above a mode list on one screen and above a player list on
 * another, and on both of them it is a fact about you rather than the thing to press. The dice is
 * the only lit element, because the dice is the only thing to do here.
 */

import { injectCss } from '@/ui/cssInjector';

const CSS = `
/* Capped rather than full width: it is a fact about you and a die, not a banner. */
.name-roller {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
  max-width: 520px;
  padding: 10px 14px;
  border: 1px solid rgba(242, 237, 227, 0.14);
  border-radius: 8px;
  background: rgba(8, 9, 11, 0.45);
}

.name-roller-label {
  font-size: clamp(11px, 3vw, 12.5px);
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: rgba(242, 237, 227, 0.6);
}

.name-roller-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: clamp(16px, 4vw, 20px);
  font-weight: 700;
  color: #f2ede3;
}

.name-roller-dice {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  min-width: 44px;
  padding: 0 16px;
  border: 1px solid #e8b34a;
  border-radius: 6px;
  background: rgba(232, 179, 74, 0.1);
  color: #e8b34a;
  font: inherit;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  cursor: pointer;
}

.name-roller-dice:hover, .name-roller-dice:focus-visible { background: rgba(232, 179, 74, 0.2); }

.name-roller-pip { font-size: 20px; line-height: 1; }
`;

export function injectNameRollerStyles(): () => void {
  return injectCss(CSS);
}
